import { gql } from '@apollo/client';

export const UPDATE_AGENCY = gql`
  mutation UpdateAgency($input: AgencyInput!) {
    updateAgency(input: $input) {
      id
      name
      logo
      description
      address
      phone
      email
      website
      facebook
      instagram
      tiktok
      firstTitle
      secondTitle
      imageCover
      theme {
        primaryColor
        secondaryColor
        accentColor
        textColor
        backgroundColor
        headerStyle
        font
      }
      popularDestinations {
        id
        name
        image
        price
      }
      aboutImage
      yearsExperience
      expertise
      satisfiedTravelers
    }
  }
`;

export const UPLOAD_FILE = gql`
  mutation UploadFile($file: String!, $agencyName: String!) {
    uploadFile(file: $file, agencyName: $agencyName) {
      url
    }
  }
`; 


// mutation pour le visitor send message 

export const VISITOR_SEND_CONTACT_MUTATION = gql`
  mutation VisitorSendContactMessage(
    $name: String!
    $email: String!
    $message: String!
    $agencyId: Int!
  ) {
    visitorSendContactMessage(
      name: $name
      email: $email
      message: $message
      agencyId: $agencyId
    ) {
      success
      message
    }
  }
`;